import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import IconButtonNonReact from '../components/IconButtonNonReact';
import Urls from '../urls/Urls';
import UrlHelper from '../core/UrlHelper';
import PlotStatus from '../site/PlotStatus';
import AssetsManager from '../assets_management/AssetsManager';
import HouseTypesViewerEntryStatusesEntry from './HouseTypesViewerEntryStatusesEntry';
import numberWithCommas from '../core/numberWithCommas';
import Star from '../components/Star';
export default class HouseTypesViewerEntryPriceRange {
	constructor({houseTypes}){
		this._houseTypes = houseTypes;
		this._element = document.createElement('div');
		this._element.classList.add('price-range');
		this._plotsToConsider =[];
		houseTypes.forEach(houseType=>this._plotsToConsider = this._plotsToConsider.concat(houseType.plots));
		this._update();
	}
	_update(){
		let minPrice = null, maxPrice = null;
		let minPriceString, maxPriceString;
		this._plotsToConsider.forEach(plotToConsider=>{
			if(plotToConsider.price===0)return;
			if(minPrice==null){
				minPrice = plotToConsider.price;
				maxPrice = minPrice;
				minPriceString = plotToConsider.priceString;
				maxPriceString = minPriceString;
				return;
			}
			if(plotToConsider.price<minPrice){
				minPrice = plotToConsider.price;
				minPriceString = plotToConsider.priceString;
			}
			if(plotToConsider.price>maxPrice){
				maxPrice = plotToConsider.price;
				maxPriceString = plotToConsider.priceString;
			}
		});
		if(minPrice===null){
			this._element.innerHTML = '';
			this._element.classList.remove('visible');
			return;
		}
		this._element.innerHTML = minPrice===maxPrice?minPriceString:`${minPriceString} - ${maxPriceString}`;
		this._element.classList.add('visible');
	}
	get element(){
		return this._element;
	}
}
